import React, { useState, useEffect } from 'react';
import {
  Modal, ModalHeader, ModalBody, Table,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { get } from 'helpers/requests';
import { BASE_URL, API } from 'CONST';
import moment from 'moment';

const EstadosDeudorHistorialModal = ({ isOpen, toggle, deudorId }) => {
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(false);
  const [motivosBloqueo, setMotivosBloqueo] = useState({});

    const fetchHistorial = () => {
      setLoading(true);
      get(`${BASE_URL}${API.historialestadosdeudoresdirect}?deudor=${deudorId}&ordering=-creation_ts`)
        .then((response) => {
          if (response && response.results) {
            setHistorial(response.results);
          } else if (Array.isArray(response)) {
            setHistorial(response);
          }
        })
        .catch((error) => {
          console.error('Error al obtener historial de estados:', error);
        })
        .finally(() => {
          setLoading(false);
        });
    };

  const fetchMotivosBloqueo = () => {
    // Fetch motivos de bloqueo if needed
    get(`${BASE_URL}${API.motivosResolucion}/`)
      .then((response) => {
        if (response && response.results) {
          const motivosMap = response.results.reduce((acc, motivo) => {
            acc[motivo.id] = motivo.name;
            return acc;
          }, {});
          setMotivosBloqueo(motivosMap);
        }
      })
      .catch((error) => {
        console.error('Error al obtener motivos de bloqueo:', error);
      });
  };

  useEffect(() => {
    if (isOpen && deudorId) {
      fetchHistorial();
      fetchMotivosBloqueo();
    }
  }, [isOpen, deudorId]);

  const getEstadoLabel = (estado) => {
    const estados = {
      vigente: 'Vigente',
      bloqueado: 'Lista Negra',
    };
    return estados[estado] || estado;
  };

  const getMotivoBloqueo = (motivoBloqueoId) => motivosBloqueo[motivoBloqueoId] || `Motivo #${motivoBloqueoId}`;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle}>
        Historial de Estados del Deudor
      </ModalHeader>
      <ModalBody>
        {loading ? (
          <div className="text-center py-4">
            <div className="spinner-border" role="status">
              <span className="sr-only">Cargando...</span>
            </div>
          </div>
        ) : (
          <>
            {historial.length > 0 ? (
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Estado</th>
                    <th>Usuario</th>
                    <th>Motivo</th>
                    <th>Usuario</th>
                  </tr>
                </thead>
                <tbody>
                  {historial.map((registro) => (
                    <tr key={registro.id}>
                      <td>{moment(registro.creation_ts).format('DD/MM/YYYY HH:mm')}</td>
                      <td>
                        <span className={`badge ${
                          registro.estado === 'vigente' ? 'badge-success' : 'badge-danger'
                        }`}
                        >
                          {getEstadoLabel(registro.estado)}
                        </span>
                      </td>
                      <td>{registro.user_name || 'Sistema'}</td>
                      <td>
                        {registro.motivo
                          || (registro.motivo_bloqueo_id
                            ? getMotivoBloqueo(registro.motivo_bloqueo_id)
                            : '-')}
                      </td>
                      <td>
                        {registro.user.username}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="text-center text-muted">No hay historial de estados disponible</p>
            )}
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

EstadosDeudorHistorialModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  deudorId: PropTypes.number,
};

EstadosDeudorHistorialModal.defaultProps = {
  deudorId: null,
};

export default EstadosDeudorHistorialModal;